// Comparison Tabs (Section-Specific)
(function () {
  document.querySelectorAll('.comparison-tab__wrapper').forEach((tabSection) => {
    const tabs = tabSection.querySelectorAll('.comparison-tab__tabs .comparison-tab__tab');
    const tabContents = tabSection.querySelectorAll('.comparison-tab__tab-content');

    tabs.forEach((tab) => {
      tab.addEventListener('click', function () {
        let tabId = this.getAttribute('data-tab');

        // Remove 'current' class only within this section
        tabs.forEach((t) => t.classList.remove('current'));
        tabContents.forEach((content) => content.classList.remove('current'));

        // Add 'current' class to clicked tab and corresponding content
        this.classList.add('current');
        const targetContent = tabSection.querySelector(`#${tabId}`);
        if (targetContent) {
          targetContent.classList.add('current');
        }

        // move the tab to the center of the container
        const tabContainer = tabSection.querySelector('.comparison-tab__tabs');
        if (tabContainer) {
          console.log(this.offsetLeft, tabContainer.offsetWidth, this.offsetWidth);
          tabContainer.scrollTo({
            left: this.offsetLeft - tabContainer.offsetWidth / 2 + this.offsetWidth / 2,
            behavior: 'smooth',
          });
        }
      });
    });
  });
})();

// Comparison Slider (Section-Specific)
(function () {
  document.querySelectorAll('[data-component="image-comparison-slider"]').forEach((element) => {
    function setSliderState(e) {
      const sliderRange = element.querySelector('[data-image-comparison-range]');
      if (e.type === 'input') {
        sliderRange.classList.add('image-comparison__range--active');
        return;
      }
      sliderRange.classList.remove('image-comparison__range--active');
    }

    function moveSliderRange(e) {
      const slider = element.querySelector('[data-image-comparison-slider]');
      const imageWrapperOverlay = element.querySelector('[data-image-comparison-overlay]');
      const container = element.getBoundingClientRect();

      let value = parseFloat(e.target.value || e.target.getAttribute('value')) / 100;
      if (isNaN(value)) {
        value = parseFloat(document.querySelector('[data-image-comparison-range]').value) / 100;
      }

      if (value > 0.02 && value < 0.98) {
        let position = value * container.width;
        slider.style.left = `${position}px`;
        imageWrapperOverlay.style.width = `${position}px`;
        setSliderState(e);
      }
    }

    function setImageWidth() {
      const pageWidthElement = document.querySelector('.page-width');
      const comparisonImages = element.querySelectorAll('.image-comparison__image');

      if (pageWidthElement && comparisonImages.length > 0) {
        const width = pageWidthElement.clientWidth + 'px';
        comparisonImages.forEach((img) => {
          img.style.width = width;
        });
      }
    }

    function init() {
      const sliderRange = element.querySelector('[data-image-comparison-range]');
      sliderRange.addEventListener('input', moveSliderRange, { passive: true });
      sliderRange.addEventListener('change', moveSliderRange, { passive: true });

      sliderRange.addEventListener('pointerdown', moveSliderRange);
      sliderRange.addEventListener('pointerup', moveSliderRange);
      // sliderRange.addEventListener('touchmove', moveSliderRange);
      // sliderRange.addEventListener('touchstart', moveSliderRange);
      // sliderRange.addEventListener('touchend', moveSliderRange);

      setImageWidth(); // Set initial width
      window.addEventListener('resize', setImageWidth); // Update width on resize
    }

    init();
  });
})();

const appstleManipulationAll = () => {
  const appstleWrapper = document.querySelector('.product .appstle_subscription_wrapper');
  if (!appstleWrapper) return;
  const isSubscriptionOn = appstleWrapper.querySelector('.appstle_subscription_radio_wrapper input:checked');
  let regularPrice = document.querySelector('.product .price__regular')?.dataset?.regularPrice;
  let originlSaveMoney = document.querySelector('.product .price__sale .price-item.price-item--sale-amount')?.dataset
    ?.originalSalePrice;
  let saveMoney = document.querySelector('.product .price__regular')?.dataset?.subscriptionSave;
  let subscriptionPrice = document.querySelector('.product .price__regular')?.dataset?.sellingPrice;
  if (isSubscriptionOn) {
    document.querySelector('.product .price.price--large').classList.add('price--on-sale');
    document.querySelector('.product .price__sale .price-item--sale.price-item--last').textContent = subscriptionPrice;
    document.querySelector('.product .price__sale .price-item.price-item--sale-amount').textContent = saveMoney;
    if (!document.querySelector('.product .price__regular')?.dataset?.comparePrice) {
      document.querySelector('.product .price__sale .price-item.price-item--regular').textContent = regularPrice;
    }
  } else {
    if (!document.querySelector('.product .price__regular')?.dataset?.comparePrice) {
      document.querySelector('.product .price.price--large').classList.remove('price--on-sale');
    } else {
      document.querySelector('.product .price__sale .price-item--sale.price-item--last').textContent = regularPrice;
      document.querySelector('.product .price__sale .price-item.price-item--sale-amount').textContent =
        originlSaveMoney;
    }
  }
};

if (!customElements.get('subscription-widget')) {
  class SubscriptionWidget extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('change', this.onChange.bind(this));
      if (this.querySelector('input[type=radio]:checked')?.value === 'subscription') {
        this.updateSubscriptionPrice();
      }
    }

    tooltip() {
      const intialElement = this.closest('.drawer__upsell') || this.closest('.video-reels_modal__footer');
      if (!intialElement) return;
      if (!this.querySelector('.tooltip')) return;
      const height = this.querySelector('.tooltip').offsetHeight;
      this.querySelector('.tooltip').style.top = `-${height + 12}px`;
    }

    onChange(event) {
      const inputValue = event.target.value;
      if (inputValue === 'subscription') {
        this.updateSubscriptionPrice();
      } else {
        this.updateSinglePrice();
      }
    }

    updateSubscriptionPrice() {
      this.querySelector('.product-selling-plan-id').disabled = false;
      let productEl = this.closest('.product__info-wrapper');
      if (this.closest('quick-add-modal')) {
        productEl = this.closest('quick-add-modal');
      }
      if (!productEl) return;
      const regularPrice = productEl.querySelector('.price__regular')?.dataset?.regularPrice;
      const saveMoney = productEl.querySelector('.price__regular')?.dataset?.subscriptionSave;
      const subscriptionPrice = productEl.querySelector('.price__regular')?.dataset?.sellingPrice;

      productEl.querySelector('.price.price--large')?.classList.add('price--on-sale');
      productEl.querySelector('.price__sale .price-item--sale.price-item--last').textContent = subscriptionPrice || '';
      productEl.querySelector('.price__sale .price-item.price-item--sale-amount').textContent = saveMoney || '';

      if (!productEl.querySelector('.price__regular')?.dataset?.comparePrice) {
        productEl.querySelector('.price__sale .price-item.price-item--regular').textContent = regularPrice || '';
      }
    }

    updateSinglePrice() {
      this.querySelector('.product-selling-plan-id').disabled = true;
      let productEl = this.closest('.product__info-wrapper');
      if (this.closest('quick-add-modal')) {
        productEl = this.closest('quick-add-modal');
      }
      if (!productEl) return;

      const priceRegularEl = productEl.querySelector('.price__regular');
      const hasComparePrice = priceRegularEl?.dataset?.comparePrice;

      if (!hasComparePrice) {
        productEl.querySelector('.price.price--large')?.classList.remove('price--on-sale');
      } else {
        const regularPrice = priceRegularEl?.dataset?.regularPrice;
        const originalSave = productEl.querySelector('.price__sale .price-item.price-item--sale-amount')?.dataset
          ?.originalSalePrice;

        productEl.querySelector('.price__sale .price-item--sale.price-item--last').textContent = regularPrice || '';
        productEl.querySelector('.price__sale .price-item.price-item--sale-amount').textContent = originalSave || '';
      }
    }
  }

  customElements.define('subscription-widget', SubscriptionWidget);
}

class RotatingBrand extends HTMLElement {
  connectedCallback() {
    const words = this.dataset.words?.split(',').map((w) => w.trim().toLowerCase().replace(/[-_]/g, ' ')) || [];
    const speed = parseFloat(this.dataset.speed || 2) * 1000; // default 2s
    if (words.length === 0) return;

    let currentIndex = 0;
    let intervalId;
    let isPaused = false;

    const updateWord = () => {
      currentIndex = (currentIndex + 1) % words.length;
      this.textContent = words[currentIndex];
    };

    const startRotation = () => {
      if (!intervalId) {
        intervalId = setInterval(updateWord, speed);
        isPaused = false;
      }
    };

    const stopRotation = () => {
      clearInterval(intervalId);
      intervalId = null;
      isPaused = true;
    };

    const handleMenuHover = () => {
      const menuItems = document.querySelectorAll('.header__menu-item');

      menuItems.forEach((menuItem) => {
        const menuText = menuItem.dataset.handle?.toLowerCase().replace(/[-_]/g, ' ');
        const matchedIndex = words.findIndex((word) => word === menuText);

        if (matchedIndex > -1) {
          const detailsEl = menuItem.closest('details');
          const megaMenuContent = detailsEl?.querySelector('.mega-menu__content');

          menuItem.addEventListener('mouseenter', () => {
            stopRotation();
            currentIndex = matchedIndex;
            this.textContent = words[currentIndex];
          });

          menuItem.addEventListener('mouseleave', () => {
            if (isPaused) {
              startRotation();
              currentIndex = (currentIndex + 1) % words.length;
              updateWord();
            }
          });

          if (megaMenuContent) {
            megaMenuContent.addEventListener('mouseenter', () => {
              stopRotation();
              currentIndex = matchedIndex;
              this.textContent = words[currentIndex];
            });

            megaMenuContent.addEventListener('mouseleave', () => {
              if (isPaused) {
                startRotation();
                currentIndex = (currentIndex + 1) % words.length;
                updateWord();
              }
            });
          }
        }
      });
    };

    startRotation();
    handleMenuHover();
  }
}

customElements.define('rotating-brand', RotatingBrand);
